import React from 'react';

import './index.module.less';

import HalfScreenInfoModal from '@components/HalfScreenInfoModal';
import CommonBtn from '@components/CommonBtn';
import ConfirmModal from '@views/components/ConfirmModal';

interface IProps {
  onClose: () => void;
  onDelete: () => void;
  onEdit: () => void;
}

const EditPhoneMenu = (props: IProps) => {
  const onEditClick = () => {
    props.onClose && props.onClose();
    props.onEdit && props.onEdit();
  }

  const onDeleteClick = () => {
    props.onClose && props.onClose();
    ConfirmModal.show({
      title: '确认删除？',
      showCancelBtn: true,
      text: '删除后，将无法恢复。',
      cancelBtnText: '取 消',
      confirmBtnText: '删 除',
      confirmTheme: 'warn',
      onConfirm: handleDelete
    });
  }

  const handleDelete = async () => {
    props.onDelete && props.onDelete();
  }

  return (
    <HalfScreenInfoModal
      height="4.8rem"
      onClose={ props.onClose }
      hideCloseBtn={ true }
    >
      <div className='flex' styleName='menu-container'>
        <div className='flex' styleName='menu-item' onClick={onEditClick}>修改联系人</div>
        <div className='flex' styleName='menu-item delete' onClick={onDeleteClick}>删除</div>
      </div>
      <CommonBtn
        type="fixed"
        btnText="取 消"
        onConfirm={ props.onClose }
        style={{ background: '#F2F4F7', color: '#55585C', fontSize: '.32rem', marginBottom: '.48rem' }}
      />
    </HalfScreenInfoModal>
  )
}

export default EditPhoneMenu;